
export default function Contact() {
  const mailtoLink = `mailto:contact@luxas.jp?subject=${encodeURIComponent('Web制作・SNS運用についてのご相談')}&body=${encodeURIComponent(`ご希望の内容（Web制作／SNS運用／Webマーケティング／その他）

ご相談の内容

会社名・屋号

ご担当者様

ご希望の返信方法（メール／LINE）

ご連絡先

参考URL（ご自身のWebサイトやSNS、または参考にしたいページなど）`)}`;

  return (
    <section className="py-16 px-8 md:px-16 lg:px-24">
      <div className="max-w-3xl mx-auto text-center">
        {/* Section Title */}
        <h2 className="text-4xl md:text-5xl font-light text-white mb-16 tracking-[0.2em]">
          ご相談・お問い合わせ
        </h2>

        {/* Contact Buttons */}
        <div className="flex flex-col gap-6 items-center">
          {/* LINE Button */}
          <a 
            href="https://line.me/R/ti/p/@598zbakd?oat_content=url&ts=01161609" 
            target="_blank" 
            rel="noopener noreferrer"
            className="w-full max-w-md px-8 py-5 bg-white text-gray-900 font-light text-lg tracking-wide rounded-sm hover:bg-gray-100 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-line-fill text-2xl"></i>
            <span>LINEで気軽に相談する</span>
          </a>

          {/* Email Button */}
          <a 
            href={mailtoLink}
            className="w-full max-w-md px-8 py-5 border border-white/30 text-white font-light text-lg tracking-wide rounded-sm hover:bg-white/10 transition-all duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-2xl"></i>
            <span>メールで問い合わせる</span>
          </a>
        </div>
      </div>
    </section>
  );
}
